import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import storage from "redux-persist/lib/storage";
import AuthService from "utils/authService";
import faqQuestion from "assets/icons/faq-questions.svg";

const handleMenuKey = (type) => {
  switch (type) {
    case "PROFILE":
      return "/profile";
    case "ASSET":
      return "/assets";
    case "BANK":
      return "/card";
    case "INVEST":
      return "/funds";
    case "HOME":
      return "/home";

    default:
      return "/";
  }
};

export const menuItemsTransformer = (input) => {
  const data = [];
  input?.map((item) =>
    data.push({
      label: item?.name,
      key: handleMenuKey(item?.type),
      icon: item?.not_active_icon,
      activeIcon: item?.active_icon,
      newFeature: item?.is_new_feature,
    })
  );
  return data;
};

const handleLogout = async () => {
  storage.removeItem("persist:root");
  localStorage.clear();
  Cookies.remove("profile");
  await AuthService.logout();
  // window.location.href = "/";
};

export const handlePageTitle = (
  page,
  userPma,
  pma,
  dscode,
  fundName,
  faqId,
  rulesTitle,
  translate
) => {
  switch (page) {
    case "/home":
      return translate("my-firouzeh");
    case "/assets":
      return translate("asset-page.title");
    case `/user-pma/${userPma?.prx}`:
      return userPma?.plan_name;
    case "/pma":
      return translate("pma-page.title");
    case "/pma-transactions":
      return translate("asset-page.pma-transactions");
    case "/pma-stocks":
      return translate("asset-page.pma-stocks");
    case "/funds":
      return translate("fund-page.title");
    case `/funds/${dscode}`:
      return `${translate("fund")} ${fundName}`;
    case `/buy`:
      return `خرید واحدهای ${fundName}`;
    case `/payment`:
      return translate("payment.title");
    case `/payment/receipt`:
      return translate("payment.receipt-title");
    case `/sell`:
      return `${translate("sell-order.title")} ${fundName}`;
    case "/accounts":
      return translate("sell-order.pre-order");
    case "/fund-transactions":
    case `/fund-transactions/${dscode}`:
      return translate("fund-page.fund-transactions");
    case "/fund-orders":
    case `/fund-orders/${dscode}`:
      return translate("fund-page.fund-orders");
    case "/user-info":
      return translate("profile-page.user-info");
    case "/onboarding":
      return translate("profile-page.activation");
    case `/pma/${pma?.id}`:
      return pma?.name;
    case `/profile`:
      return translate("profile");
    case `/faq`:
    case `/faq/${faqId}`:
      return translate("profile-page.faq");
    case "/fund-order/buy":
      return translate("fund-page.fund-orders-buy-detail");
    case "/fund-order/sell":
      return translate("fund-page.fund-orders-sell-detail");
    case "/change-broker":
      return translate("change-broker.title");
    case "/chat-bot":
      return translate("chat-bot.title");
    case "/card":
      return translate("card-page.promotion-title");
    case "/bank-onboarding":
      return translate("card-page.create");
    case "/bank-onboarding/base-info":
      return translate("card-page.accept-info");
    case "/bank-onboarding/bank-card":
      return translate("card-page.choose-card");
    case "/bank-onboarding/bank-video":
      return translate("card-page.create-video");
    case "/bank-onboarding/bank-address":
      return translate("card-page.address");
    case "/bank/asset-back":
      return translate("asset-back-title");
    case "/bank/transactions":
      return translate("bank-transactions-title");
    case "/referral":
      return translate("referral");
    case "/prize":
      return translate("prize-page.title");
    case "/fast-invest":
      return translate("card-page.fast-invest-title");
    case "/bank/setting":
      return translate("bank.card-setting");
    case "/bank/orders":
      return translate("bank.transactions-order-list");
    case "/fund/deposit-certificate":
      return translate("fund-page.fund-deposit-certificate");
    case "/fund/account-history":
      return translate("fund-page.account-history");
    case "/regulation":
      return translate("profile-page.ruls-regulation");
    case "/regulation-pdf":
      return rulesTitle;
    case "/fund/profit-sharing":
      return translate("fund-page.profit-detail");
    case "/bank/increase-amount":
      return translate("card-page.Increase-inventory");
    case "/cardex":
      return translate("fund-page.cardex-investor");
    case "/voucher":
      return translate("voucher.title");
    default:
      return null;
  }
};

export const handleAdditionalHeader = (
  page,
  prx,
  dscode,
  translate,
  onClick,
  handleQuestionBtn
) => {
  switch (page) {
    // case `/user-pma/${prx}`:
    //   return (
    //     <Link to="/pma-transactions">
    //       {translate("asset-page.pma-transaction")}
    //     </Link>
    //   );

    case `/funds/${dscode}`:
      return (
        <Link
          to={`/fund-orders/${dscode}`}
          onClick={() => onClick("fund-button-orders", dscode)}
        >
          {translate("history")}
        </Link>
      );
    case "/fund-orders":
      return (
        <Link
          to={`/fund-transactions`}
          onClick={() => onClick("orders-button-transactions")}
        >
          {translate("transactions")}
        </Link>
      );
    case `/fund-orders/${dscode}`:
      return (
        <Link
          to={`/fund-transactions/${dscode}`}
          onClick={() => onClick("orders-button-transactions", dscode)}
        >
          {translate("transactions")}
        </Link>
      );

    case "/pma":
      return (
        <img src={faqQuestion} alt="icon" onClick={() => handleQuestionBtn()} />
      );

    case "/cardex":
      return (
        <Link onClick={() => window.print()}> {translate("pdf-download")}</Link>
      );
    default:
      return "";
  }
};

export const defaultMenu = () => {
  return [
    {
      priority: 1,
      type: "HOME",
      name: "خانه",
      is_default: true,
      active_icon: "https://cdn.firouzeh.com/public/home-selected.svg",
      not_active_icon: "https://cdn.firouzeh.com/public/home.svg",
      is_new_feature: null,
    },
    {
      priority: 2,
      type: "ASSET",
      name: "دارایی",
      is_default: false,
      active_icon: "https://cdn.firouzeh.com/public/asset-selected.svg",
      not_active_icon: "https://cdn.firouzeh.com/public/asset.svg",
      is_new_feature: null,
    },
    {
      priority: 3,
      type: "PROFILE",
      name: "پروفایل",
      is_default: false,
      active_icon: "https://cdn.firouzeh.com/public/profile-selected.svg",
      not_active_icon: "https://cdn.firouzeh.com/public/profile.svg",
      is_new_feature: null,
    },
  ];
};
